import { ProgressbarPartType } from "./MultiPartProgressbar.types";
import {
    ProgressbarPartBar,
    ProgressbarPartContainer,
    ProgressbarPartLabel,
} from "./MultiPartProgressbar.styles";

const MINIMUM_WIDTH_PERCENTAGE = 20;

export function ProgressbarPart({ value, label }: ProgressbarPartType) {
    return (
        <ProgressbarPartContainer
            style={{ width: Math.max(MINIMUM_WIDTH_PERCENTAGE, value) + "%" }}
        >
            <ProgressbarPartBar />
            <ProgressbarPartLabel>{label}</ProgressbarPartLabel>
        </ProgressbarPartContainer>
    );
}
